import { useRef } from "react";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { OverlayPanel } from "primereact/overlaypanel";
import { useAuth } from "../../contexts/AuthContext";
import { useTheme, GRADIENT_PRESETS } from "../../contexts/ThemeContext";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { user, logout } = useAuth();
  const { accentId, setAccent } = useTheme();
  const navigate = useNavigate();
  const colorPanelRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/logout");
  };

  return (
    <div className="shadow-2 surface-0">
      <div className="flex align-items-center justify-content-between px-4 py-2">
        <div className="flex align-items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" />
        </div>

        {user && (
          <div className="flex align-items-center gap-3">
            <div className="flex align-items-center gap-2">
              <Avatar icon="pi pi-user" shape="circle" className="surface-200" />
              <span className="font-medium">{user.firstname} {user.lastname}</span>
            </div>

            <Button
              icon="pi pi-palette"
              className="p-button-rounded p-button-text"
              onClick={(e) => colorPanelRef.current.toggle(e)}
              tooltip="Цвет фона"
              tooltipOptions={{ position: "bottom" }}
            />

            <OverlayPanel ref={colorPanelRef} style={{ width: '220px' }}>
              <div className="font-medium mb-2">Цвет фона</div>
              <div className="flex flex-wrap gap-2">
                {GRADIENT_PRESETS.map((preset) => (
                  <div
                    key={preset.id}
                    className="cursor-pointer border-round-lg flex align-items-center justify-content-center"
                    style={{
                      width: '40px',
                      height: '40px',
                      background: preset.gradient,
                      border: accentId === preset.id ? '3px solid var(--primary-color)' : '2px solid transparent',
                      transition: 'border 0.2s',
                    }}
                    title={preset.label}
                    onClick={() => {
                      setAccent(preset.id);
                      colorPanelRef.current.hide();
                    }}
                  >
                    {accentId === preset.id && (
                      <i className="pi pi-check text-white text-sm"></i>
                    )}
                  </div>
                ))}
              </div>
            </OverlayPanel>

            <Button
              icon="pi pi-power-off"
              className="p-button-rounded p-button-text p-button-danger"
              onClick={handleLogout}
              tooltip="Выход"
              tooltipOptions={{ position: "bottom" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
